export default {"src":"/_next/static/media/candy.2201a672.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};